import Vue from 'vue'

export type AlertType = undefined | 'success' | 'info' | 'warning' | 'error'

export default Vue.extend({
  name: 'AlertMixin',
  data() {
    return {
      alert: {
        show: false,
        message: '',
        type: undefined as AlertType
      }
    }
  },
  methods: {
    resetAlert() {
      this.alert.show = false
      this.alert.type = undefined
      this.alert.message = ''
    },
    showAlert(message: string, type: AlertType = undefined) {
      this.alert.show = true
      this.alert.type = type
      this.alert.message = message
    }
  }
})
